import React, { useState, useRef, useEffect } from 'react';
import * as d3 from 'd3';
import '../styles/Charts.css';

const ChartBarNominal = ({dataProps}) => {
    // preset data if data props not given
    const [dataBar, updateDataBarNominal] = useState([
        {property: 'Students', value: 10},
        {property: 'Alumni', value: 19}
    ]) 
    
    const data = dataProps || dataBar;
    const svgRef = useRef();

    const width = 600;
    const height = 300;

    const margin = { 
        top: 20,
        right: 30,
        bottom: 100,
        left: 60
    };  

    useEffect(()=>{
        if (!data || data.length === 0) return;

        const svg = d3.select(svgRef.current)
            .attr('width', width + margin.left + margin.right)
            .attr('height', height + margin.top + margin.bottom);

        svg.append('g')
            .attr('transform', '`translate(${margin.left}, ${margin.top})`');

        svg.selectAll('*').remove();

        const chartArea = svg.append('g')
            .attr('transform', `translate(${margin.left}, ${margin.top})`);

        // X scale
        const x = d3.scaleLinear()
            .domain([0, d3.max(data, d => d.value)])
            .nice()
            .range([height, 0]);

        // Y scale
        const y = d3.scaleBand()
            .domain(data.map(d => d.property))
            .range([0, height])
            .padding(0.1);

        // Draw bars
        chartArea.selectAll(".bar")
            .data(data)
            .enter()
            .append("rect")
            .attr("class", "bar")
            .attr("x", 0)
            .attr("y", d => y(d.property))
            .attr("width", d => x(d.value))
            .attr("height", 50)
            .attr("fill", "#69b3a2");

        // Add labels
        chartArea.selectAll(".label")
            .data(data)
            .enter()
            .append("text")
            .attr("class", "label")
            .attr("x", d => x(d.value) + 5) 
            .attr("y", d => y(d.property) + y.bandwidth() / 2)
            .attr("dy", "0.35em")
            .text(d => d.value)
            .attr("class", "text-label");

        // Draw x axis
        chartArea.append("g")
            .attr("class", "x-axis")
            .attr("transform", `translate(0, ${height})`)
            .call(d3.axisBottom(x));

        // Draw y axis
        chartArea.append("g")
            .attr("class", "y-axis")
            .call(d3.axisLeft(y));


    }, [data]);

    return (
        <div>
            <article id='labelsBar'>
                {/* data legend will be here */}
            </article>
            <svg
            ref={svgRef}
            // width={width}
            // height={height}
            >
            </svg>
        </div>  
    )
}

export default ChartBarNominal